module.exports = __webpack_public_path__ + "static/img/6.a5153b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/6.png
// module id = RMOg
// module chunks = 0